import styled from '@emotion/styled';
import { colors } from 'constants/colors';

export const MessageContainer = styled('div')({
  backgroundColor: colors.MAUVELOUS,
  margin: '0px 20px',
  padding: '10px',
  borderRadius: 5,
});
